import useClearSessionFilter from './components/Hooks/useClearSessionFilter'

export default function ClearSessionFilter() {

  useClearSessionFilter('merchantsFilter', ['organization', 'transaction']);
  useClearSessionFilter('agentsFilter', ['agent', 'agent/organization']);
  useClearSessionFilter('payoutsFilter', ['payout']);
  useClearSessionFilter('instantPaymentsFilter', ['instant-payment', 'transaction']);
  useClearSessionFilter('transactionsFilter', ['transaction']);
  useClearSessionFilter('merchantTransactionsFilter', ['transaction']);

  return null;
}
